// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---gatsby-static-templates-page-js": () => import("./../../../gatsby/static/templates/page.js" /* webpackChunkName: "component---gatsby-static-templates-page-js" */)
}

